/**
 * Reguli comune pentru deponenti: persoana fizica sau juridica, numele afisat
 * si datele trimise in sabloanele de contract.
 */

export const DEPOSITOR_PERSON = 'pf';
export const DEPOSITOR_COMPANY = 'pj';

/** Deponentii vechi nu au `type` si sunt persoane fizice. */
export function isCompany(depositor: any): boolean {
    return !!depositor && depositor.type === DEPOSITOR_COMPANY;
}

/** Persoana fizica, respectiv reprezentantul firmei. */
export function depositorPersonName(depositor: any): string {
    if (!depositor) return '';
    return `${depositor.firstName || ''} ${depositor.lastName || ''}`.trim();
}

/** Numele afisat: denumirea firmei la persoana juridica. */
export function depositorName(depositor: any): string {
    if (isCompany(depositor)) {
        return depositor.companyName || '';
    }
    return depositorPersonName(depositor);
}

/** `DepositorContractStatus.PENDING` din API: contract inca nesemnat. */
export const CONTRACT_PENDING = 0;

/**
 * De ce lotul din licitatie nu poate trece in alt contract, sau '' daca poate.
 * Oglindeste regulile din API (`transferAuctionLotsToContract`) doar pentru
 * checkbox-ul dezactivat - verificarea reala, inclusiv ofertele, e pe server.
 */
export function contractTransferBlockReason(lot: any, auction: any): string {
    // AuctionStatus 0 = pending, 3 = done. In pregatire / live preturile
    // sunt deja generate din pretul de pornire.
    if (!auction || (auction.status !== 0 && auction.status !== 3)) {
        return 'Se poate doar înainte de pregătirea live-ului sau după încheierea licitației';
    }
    if (lot.sold || lot.soldManually) return 'Lot adjudecat';
    if (lot.isUnavailable) return 'Lot indisponibil';
    if (lot.status === 1) return 'Lot în desfășurare în live';
    if (lot.winnerBid) return 'Lotul are oferte';
    if (!lot.depositorContract) return 'Lot fără contract de deponent';
    return '';
}

/** Optiunile pentru `v-select`, eventual fara deponentul dat. */
export function depositorOptions(depositors: any[], excludeId?: string) {
    return depositors
        .filter((depositor: any) => depositor._id !== excludeId)
        .map((depositor: any) => ({
            label: depositorName(depositor),
            value: depositor._id,
        }));
}

export function emptyDepositor() {
    return {
        type: DEPOSITOR_PERSON,
        firstName: '',
        lastName: '',
        series: '',
        number: '',
        pin: '',
        companyName: '',
        cui: '',
        registrationNumber: '',
        address: '',
        phone: '',
        email: '',
        bankAccount: '',
    };
}

/**
 * Campurile `depositor_*` din sabloanele DOCX. Sabloanele aleg randurile de
 * persoana fizica / juridica dupa `depositor_is_company`. Aceeasi mapare e si
 * in API, la PDF-ul de semnare (api.vikart.ro/src/lib/contract-pdf.ts).
 */
export function depositorDocxData(depositor: any) {
    const d = depositor || {};

    return {
        depositor_is_company: isCompany(d),
        depositor_name: depositorName(d),
        depositor_address: d.address || '',
        depositor_id: `${d.series || ''} ${d.number || ''}`.trim(),
        depositor_series: d.series || '',
        depositor_number: d.number || '',
        depositor_pin: d.pin || '',
        depositor_cui: d.cui || '',
        depositor_reg_com: d.registrationNumber || '',
        depositor_representative: depositorPersonName(d),
        depositor_phone: d.phone || '',
        depositor_email: d.email || '',
        depositor_bank: d.bankAccount || '',
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/depositor.ts